// api.ts
import config from "@lib/config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { Auth } from "aws-amplify";

export const riotApi = createApi({
  reducerPath: 'riotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_ENDPOINT,
    prepareHeaders: async (headers) => {
      const session = await Auth.currentSession();
      headers.set('authorization', `Bearer ${session.getIdToken().getJwtToken()}`);
      return headers;
    }
  }),
  tagTypes: ['User'], // Add any other tag types you need
  refetchOnMountOrArgChange: 15,
  refetchOnReconnect: true,
  refetchOnFocus: true,
  endpoints: () => {
    return {
      /**
       * base query does not implement endpoints.
       * endpoints are added by injection in the respective api slices.
       */
    };
  },
});

// Export hooks and utilities
export const {
  util: { resetApiState },
} = riotApi;
